import * as z from "zod";
import {DetailResModel} from "./DetailResModel";

const schema = z.object({
	content: z.array(DetailResModel.model).default([]),
	currentPage: z.number().default(0),
	pageSize: z.number().default(20),
	totalCount: z.number().default(0),
	totalPages: z.number().default(0)
});

const model = schema.transform((values) => ({
	...values
}));

export const TaxAccountantDetailResModel = {schema, model};
export type ITaxAccountantDetailResModel = z.infer<typeof TaxAccountantDetailResModel.model>;
export const DEFAULT_TAX_ACCOUNTANT_DETAIL_RES: ITaxAccountantDetailResModel = {
	content: [],
	currentPage: 0,
	pageSize: 20,
	totalCount: 0,
	totalPages: 0
};
